import { useState } from "react";
import TextField from "../components/TextField";
import Button from "../components/Button";
import { forgotPasswordAPI } from "../api/auth";


export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await forgotPasswordAPI(email);
      setSent(true);
    } catch (err) {
      alert(err.message);
    }

    setLoading(false);
  };

  return (
    <section className="bg-gray-50 min-h-screen flex items-center justify-center">
      <div className="bg-white p-6 shadow rounded w-full max-w-md">
        <h1 className="text-xl font-bold mb-6">Forgot Password</h1>

        {sent ? (
          <p className="text-green-600">Reset link has been sent to your email.</p>
        ) : (
          <form className="space-y-4" onSubmit={handleSubmit}>
            <TextField
              label="Your Email"
              type="email"
              value={email}
              placeholder="name@company.com"
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Reset Link"}
            </Button>
          </form>
        )}
      </div>
    </section>
  );
}
